import { render, staticRenderFns } from "./ReferenceFramesTooltip.vue?vue&type=template&id=cd2f7a30&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports